export function ordinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'] as const
  const v = n % 100
  return `${n}${s[(v - 20) % 10] ?? s[v] ?? s[0]}`
}

/** A countdown as "2h 5m" or "5m" (never less than a minute while any time is left). */
export function formatRemaining(ms: number): string {
  const h = Math.floor(ms / 3_600_000)
  const m = Math.max(ms > 0 ? 1 : 0, Math.floor((ms % 3_600_000) / 60_000))
  return h > 0 ? `${h}h ${m}m` : `${m}m`
}

/** `plural(1, 'move')` → "1 move", `plural(3, 'move')` → "3 moves". */
export function plural(n: number, singular: string, pluralForm = `${singular}s`): string {
  return `${n} ${n === 1 ? singular : pluralForm}`
}
